import React from 'react';
import CarInputComponent from './CarInputComponent';
import useIsNLplan from '../../../../../../common/src/hooks/useIsNLPlan';
import { FlowsQuestion } from '../../../../types/FlowsTypes';

interface Props {
  question: FlowsQuestion;
}

const CarInputPicker: React.FC<React.PropsWithChildren<Props>> = ({
  ...props
}) => {
  const { isNL } = useIsNLplan();

  switch (null) {
    default:
      return (
        <CarInputComponent withVin={!isNL} withLicensePlate={isNL} {...props} />
      );
  }
};

export default CarInputPicker;
